module.exports = __webpack_public_path__ + "static/img/信息1.6ffeaff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/信息1.png
// module id = pMeI
// module chunks = 1